import { ReactNode } from "react";
import { isFeatureEnabled, FeatureFlagKey } from "@/lib/feature-flags";
import ComingSoon from "@/components/ComingSoon";

interface FeatureGateProps {
  flag: FeatureFlagKey;
  /** Feature title shown on the Coming Soon screen */
  feature: string;
  description?: string;
  highlights?: string[];
  source?: string;
  children: ReactNode;
}

/**
 * Renders children only when the feature flag is enabled.
 * Otherwise shows a branded Coming Soon page with a waitlist CTA.
 */
export default function FeatureGate({
  flag,
  feature,
  description,
  highlights,
  source,
  children,
}: FeatureGateProps) {
  if (isFeatureEnabled(flag)) {
    return <>{children}</>;
  }

  return (
    <ComingSoon
      feature={feature}
      description={description}
      highlights={highlights}
      source={source}
    />
  );
}